// extracted by mini-css-extract-plugin
export var Container = "default-module--Container--PekOn";
export var Contents = "default-module--Contents--20UlR";
export var Information = "default-module--Information--2BQqe";